import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewChecked,
  ElementRef,
  ViewChild
} from '@angular/core';


import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit, AfterViewChecked{
  @ViewChild('messageBox', { static: true }) private myScrollContainer: ElementRef;
  @Input() messages:String[];
  @Output() send = new EventEmitter<String>();
  newMessage:String;

  constructor(public translate: TranslateService){

  }

  ngOnInit(){
  }

  ngAfterViewChecked(){
    this.scrollDown()
  }

  scrollDown(){
    this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
  }

  sendMessage(){
    this.send.emit(this.newMessage);
    this.newMessage = '';
    this.scrollDown();
  }
}
